















import {
  Component, Prop, Watch,
} from 'vue-property-decorator';

import MarkdownToHTML from '@/common/MarkdownToHTML';

import BaseView from '@/views/BaseView.vue';
import DesignResource from '@/models/exam/DesignResource';

import ExamInfo from '@/models/exam/ExamInfo';
import ScoreLevel from '@/models/exam/ScoreLevel';

@Component
export default class ExamResultRankScoreLevel extends BaseView {
  @Prop({ type: ScoreLevel })
  private scoreLevel: ScoreLevel;

  @Prop()
  private examInfo: ExamInfo|null;

  @Prop()
  private scoreLevelDesignResource: DesignResource;

  private explanation = '';

  private notes = '';

  private scoreLevelName = '';

  private cssClassName = '';

  private scoreLevelTitle = '判定結果';

  private scoreLevelResourceUri = '';

  private alternativeText = '';

  mounted() {
    this.watchScoreLevel();
    this.watchScoreLevelResource();
  }

  @Watch('scoreLevel')
  watchScoreLevel() {
    this.scoreLevelName = this.scoreLevel.name || '';
    this.explanation = MarkdownToHTML(this.scoreLevel.explanation) || '';
    this.notes = MarkdownToHTML(this.scoreLevel.notes) || '';
    this.scoreLevelResourceUri = this.scoreLevel.resourceUri || '';
    this.alternativeText = this.scoreLevel.alternativeText || '';
  }

  @Watch('scoreLevelDesignResource')
  watchScoreLevelResource() {
    this.cssClassName = this.scoreLevelDesignResource.cssClassName;
    this.scoreLevelTitle = this.scoreLevelDesignResource.displayText || this.scoreLevelTitle;
  }
}
